"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingMetadataTelemetryProcessor = void 0;
/**
 * BillingMetadataTelemetryProcessor injects billing metadata from to all telemetry
 * events, if custom billing data is not yet provided.
 */
class BillingMetadataTelemetryProcessor {
    constructor(billingMetadata) {
        this.billingMetadata = billingMetadata;
    }
    processEvent(event) {
        if (!event.parameters.billingMetadata) {
            event.parameters.billingMetadata = this.billingMetadata;
        }
    }
}
exports.BillingMetadataTelemetryProcessor = BillingMetadataTelemetryProcessor;
//# sourceMappingURL=billing.js.map